import Api from '@/services/Api'

export default {
  getAllGrupos() {
    return Api().get("/grupos");
  },

  get(id) {
    return Api().get(`/grupos/${id}`);
  },

  create(data) {
    return Api().post("/grupos/create", data);
  },

  update(id, data) {
    return Api().put(`/grupos/update/${id}`, data);
  },

  delete(id) {
    return Api().put(`/grupos/delete/${id}`);
  }
}